import "./InputGlobal.scss";

export const InputGlobal = ({
  placeholder,
  name,
  onChange,
  className,
  type,
  value,
  onFocus,
}) => {
  return (
    <input
      className={className}
      type={type}
      placeholder={placeholder}
      name={name}
      autoComplete="off"
      onChange={onChange}
      value={value}
      onFocus={onFocus}
    />
  );
};
